import { ComponentProps } from 'react';

const LeftArrowIcon = (props: ComponentProps<'svg'> & { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.5 19L8.5 12L15.5 5"
        stroke={props?.color ?? '#203248'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LeftArrowIcon;
